const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/result')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}